var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.73 8 6.5-6.295a1 1 0 0 0 0-1.41 1 1 0 0 0-1.43 0L3.945 6.94a1.5 1.5 0 0 0 0 2.12l6.83 6.65a1.03 1.03 0 0 0 1.43 0 1.001 1.001 0 0 0 0-1.415L5.73 8Z"
  })));
};
export default SvgChevronLeft;